<template>
    <div>
        <component v-bind:is="dynamicComponent"></component>
        <modals-container/>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
import InternalUserInfo from "./internal/InternalUserInfo";
import ExternalUserInfo from "./external/ExternalUserInfo";
export default {
    data() {
        return {
            dynamicComponent : null,
        }
    },
    components : {
        internal : InternalUserInfo,
        external : ExternalUserInfo
    },
    mounted() {
        /* 내부or외부 사용자 조회 */
        this.getUserType();

        // 뒤로가기 이벤트 발생시 .
        const self = this;
        window.onpopstate = function (event) {
            let returnUrls = localStorage.getItem("returnUrls");
            if(returnUrls != null) {
                let urlList = returnUrls.split(",");
                if (urlList.length > 0) {
                    if (urlList.length == 1) {
                        localStorage.removeItem("returnUrls");
                        // self.$router.push("/general/home");
                    } else {
                        urlList.pop();
                        urlList.pop();
                        localStorage.setItem("returnUrls", urlList);
                        // this.$router.replace(urlList[urlList.length-1]);
                    }
                } else {
                    self.$router.push("/general/home");
                }
            }else{
                self.$router.push("/general/home");
            }
        }
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 내부or외부 사용자 조회 */
        getUserType() {
            let obj = this;
            let reqData = {
                url: "/api/auth/org/getUserType",
                method: "post",
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result !== null) {
                    if(res.result === true) {
                        obj.dynamicComponent = 'external';
                        //obj.getLoggedUserInfo(obj.dynamicComponent);
                    } else {
                        obj.dynamicComponent = 'internal';
                        //obj.getLoggedUserInfo(obj.dynamicComponent);
                    }
                }

            })
            .catch(function(err) {
                console.log(err);
            });
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/MyInfo.vue